var map = {
	"./address_image.svg": 95,
	"./animated_kevin.png": 96,
	"./animated_logo.svg": 97,
	"./blogs_image.svg": 98,
	"./boost_logo.png": 99,
	"./cloud_infrastructure.svg": 100,
	"./codeInLogo.png": 101,
	"./contactMail.png": 102,
	"./coursera_logo.png": 103,
	"./data_science.svg": 104,
	"./deeplearning_ai_logo.png": 105,
	"./developerActivity.svg": 106,
	"./education.svg": 107,
	"./experience.svg": 108,
	"./feelingProud.svg": 109,
	"./freecopy_logo.png": 110,
	"./fullstack.svg": 111,
	"./gcp_logo.png": 112,
	"./github_logo.png": 113,
	"./googleAssistant.jpg": 114,
	"./googleAssistant.svg": 115,
	"./google_logo.png": 116,
	"./jsFramework.svg": 117,
	"./legato_logo.png": 118,
	"./manOnTable.svg": 119,
	"./microsoft_logo.png": 120,
	"./portfolio.gif": 121,
	"./programmer.svg": 122,
	"./projects_image.svg": 123,
	"./pwa.png": 124,
	"./remote_logo.png": 125,
	"./saayaHealthLogo.png": 126,
	"./stanford_logo.png": 127,
	"./talksCardBack.svg": 128,
	"./talksCardBackAlt.svg": 129,
	"./ui_ux_design.svg": 130,
	"./um_logo.png": 131
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28;